import { ITHit } from "webdav.client";

const webDavSession = new ITHit.WebDAV.Client.WebDavSession();

export class WebDavService {
    

  static getCurrentFolder(sPath) {
    
    return new Promise((resolve, reject) => {
      webDavSession.OpenFolderAsync(sPath, [], (data) => {
        // console.log(data);
         if (!data.IsSuccess) 
             return reject(data.Error);
         resolve(data);
      });
     });
  }

    static getItems(currentFolder, sortColumn, sortAscending, currentPage, pageSize) {
        return new Promise((resolve, reject) => {
            currentFolder.GetPageAsync(
                [],
                (currentPage - 1) * pageSize,
                pageSize,
                WebDavService.setSortColumnsValue(sortColumn, sortAscending),
                (data) => {

                    if (!data.IsSuccess) {
                        reject(data.Error);
                        return;
                    }

                    resolve(data);
                }
            );
        });
    }
  static getItem(sPath) {
    return new Promise((resolve, reject) => {
      webDavSession.OpenItemAsync(sPath, [], (data) => {
        if (!data.IsSuccess) return reject(data.Error);
        resolve(data);
      });
    });
  }

  static createFolder(
    currentFolder,
    folderName
  ) {
    return new Promise((resolve, reject) => {
      currentFolder.CreateFolderAsync(folderName, "", [], (data) => {
        if (!data.IsSuccess) return reject(data);
        resolve(data);
      });
    });
  }

  static setSortColumnsValue(
    sortColumn,
    sortAscending
  ) {
    console.log("sort")
    const namespaceUri = "DAV:";
    const sortColumns = [
      new ITHit.WebDAV.Client.OrderProperty(
        new ITHit.WebDAV.Client.PropertyName("is-directory", namespaceUri),
        false
      ),
    ];
    console.log("sort1")
    if (sortColumn) {
      console.log("sort2")
      sortColumns.push(
        new ITHit.WebDAV.Client.OrderProperty(
          new ITHit.WebDAV.Client.PropertyName(sortColumn, namespaceUri),
          sortAscending
        )
      );
    }
    console.log(sortColumns)
    return sortColumns;
    }

    static renameItem(itemHref, newName) {
        return new Promise((resolve, reject) => {
            webDavSession.OpenItemAsync(itemHref, [], (itemData) => {
                if (!itemData.IsSuccess) {
                    reject(itemData.Error);
                    return;
                }

                const item = itemData.Result;
                const parentHref = itemHref.substring(0, itemHref.replace(/\/$/, '').lastIndexOf('/') + 1);

                webDavSession.OpenFolderAsync(parentHref, [], (folderData) => {
                    if (!folderData.IsSuccess) {
                        reject(folderData.Error);
                        return;
                    }

                    const parentFolder = folderData.Result;

                    item.MoveToAsync(
                        parentFolder,
                        newName,
                        false,
                        [],
                        (moveData) => {
                            if (!moveData.IsSuccess) {
                                reject(moveData.Error);
                                return;
                            }

                            resolve(moveData);
                        }
                    );
                });
            });
        });
    }

    static moveItem(itemHref, targetFolderHref, itemName) {
        return new Promise((resolve, reject) => {
            webDavSession.OpenItemAsync(itemHref, [], (itemData) => {
                if (!itemData.IsSuccess) {
                    reject(itemData.Error);
                    return;
                }

                webDavSession.OpenFolderAsync(targetFolderHref.replace(/\/?$/, '/'), [], (folderData) => {
                    if (!folderData.IsSuccess) {
                        reject(folderData.Error);
                        return;
                    }

                    itemData.Result.MoveToAsync(
                        folderData.Result,
                        itemName,
                        false,
                        [],
                        (moveData) => {
                            if (!moveData.IsSuccess) {
                                reject(moveData.Error);
                                return;
                            }

                            resolve(moveData);
                        }
                    );
                });
            });
        });
    }

    static async copyItem(itemHref, targetFolderHref, itemName) {
        const normalizedTargetFolderHref = targetFolderHref.replace(/\/?$/, '/');
        const destinationHref = `${normalizedTargetFolderHref}${encodeURIComponent(itemName)}`;

        const response = await fetch(itemHref, {
            method: 'COPY',
            headers: {
                Destination: destinationHref,
                Overwrite: 'F',
            },
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error(`COPY failed. Status: ${response.status}`);
        }

        return response;
    }

    static pasteItems(items, targetFolderHref) {
        const normalizedTargetFolderHref = targetFolderHref.replace(/\/?$/, '/');
        const plainItems = items.map(item => ({
            Href: item.Href,
            DisplayName: item.DisplayName,
            ResourceType: item.ResourceType,
            Action: item.Action || 'copy',
        }));

        return Promise.all(
            plainItems.map((item) => {
                if (item.Action === 'cut') {
                    return WebDavService.moveItem(
                        item.Href,
                        normalizedTargetFolderHref,
                        item.DisplayName
                    );
                }

                return WebDavService.copyItem(
                    item.Href,
                    normalizedTargetFolderHref,
                    item.DisplayName
                );
            })
        );
    }

    static folderExists(folderHref) {
        const normalizedFolderHref = folderHref.replace(/\/?$/, '/');

        return new Promise((resolve) => {
            webDavSession.OpenFolderAsync(normalizedFolderHref, [], (data) => {
                resolve(data.IsSuccess);
            });
        });
    }

    static async createFolderByHref(folderHref) {
        const normalizedFolderHref = folderHref.replace(/\/?$/, '/');

        const response = await fetch(normalizedFolderHref, {
            method: 'MKCOL',
            credentials: 'include',
        });

        if (response.ok || response.status === 405) {
            return response;
        }

        throw new Error(`MKCOL failed. Status: ${response.status}`);
    }

    static async ensureFolderExists(folderHref) {
        const normalizedFolderHref = folderHref.replace(/\/?$/, '/');

        try {
            await WebDavService.getCurrentFolder(normalizedFolderHref);
            return;
        } catch (error) {
            await WebDavService.createFolderByHref(normalizedFolderHref);
        }
    }
}